import { makeAutoObservable } from "mobx";
import { ApiResponse, IRootStore } from "..";
import Api from "../../services/api";
import { ApiConfig } from "../../services/api-config";
import _ from "lodash";
import { IAddOnOption } from "../products";

export default class AddOnOptionStore {
  addOnOptions: Array<IAddOnOption> = [];
  editAddOnOption: IAddOnOption | null = null;
  private rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  fetchAddOnOptions = () => {
    const url = ApiConfig.REST_URIS.addOnOption.fetchAddOnOptions;
    Api.get(url, (res: ApiResponse<IAddOnOption[]>) => {
      if (res?.isSuccess && res.data) {
        this.addOnOptions = _.sortBy(res.data, "addOnOptionName");
      }
    });
  };

  saveAddOnOption = (addOnOption: IAddOnOption, callback: Function) => {
    if (addOnOption.addOnOptionId) {
      Api.put(
        ApiConfig.REST_URIS.addOnOption.update(addOnOption.addOnOptionId),
        addOnOption,
        (res: ApiResponse<number>) => {
          callback && callback(res?.isSuccess && res.data);
        }
      );
    } else {
      Api.post(
        ApiConfig.REST_URIS.addOnOption.create,
        addOnOption,
        (res: ApiResponse<number>) => {
          callback && callback(res?.isSuccess && res.data);
        }
      );
    }
  };

  deleteAddOnOption = (addOnOptionId: number, callback: Function) => {
    const url = ApiConfig.REST_URIS.addOnOption.delete(addOnOptionId);

    Api.delete(url, (res: ApiResponse<number>) => {
      callback && callback(res?.isSuccess && res.data);
    });
  };

  setEditAddOnOption = (addOnOption: IAddOnOption | null) => {
    this.editAddOnOption = addOnOption;
  };
}
